module.exports = __webpack_public_path__ + "static/media/iconfinder_whatsapp_287520.547cd823.svg";